import { AppState } from '../../../../redux/reducers';
import * as FileUploadStore from '../../../../redux/middleware/FileUploadMiddleware';
import { FileUpload } from '../../../../models/Entities/Contracts/FileUpload';

export interface FileSelectorProps {
  contractId: number;
  multiple?: boolean;
  onChange?: (files: FileUpload[]) => void;
}

export interface ConnectedProps {
  isLoading: boolean;
  files: FileUpload[];
}

export interface DispatchProps {
  GetAllFileUploads: (filters?: any) => void;
}

export type Props = FileSelectorProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState): ConnectedProps => ({
  isLoading: state.FileUpload?.isLoadingAll || false,
  files: state.FileUpload?.FileUploads || [],
});

export const mapDispatchToProps = {
  GetAllFileUploads: FileUploadStore.actionCreators.GetAllFileUploads,
};
